module.exports = __webpack_public_path__ + "img/pdf1.b0c611ab.jpg";